import { useSelector } from 'react-redux';
import { featureConstant } from '@/constants/configuration/feature.js';

export function useFeature(featureName) {
	const features = useSelector((state) => state.auth?.features) || [];

	if (Array.isArray(features) && features.length > 0) {
		return features.includes(featureName);
	}

	return false;
}

export const features = featureConstant;
